module.exports = __webpack_public_path__ + "static/media/mehmet.a7679ca2.jpg";